import React from 'react';
import { Card, Badge } from 'react-bootstrap';

const PublicationItem = ({ publication }) => {
    return (
        <Card className="publication-card-bento mb-4 border-0">
            <Card.Body className="p-4">
                <div className="d-flex justify-content-between align-items-start mb-3">
                    <div className="d-flex gap-2">
                        <Badge className="pub-badge-year">
                            {publication.year}
                        </Badge>
                        <Badge className="pub-badge-journal">
                            {publication.journal}
                        </Badge>
                    </div>
                </div>

                <Card.Title className="mb-3 fw-bold" style={{ fontSize: '1.35rem' }}>
                    <a
                        href={publication.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pub-title-link"
                    >
                        {publication.title}
                    </a>
                </Card.Title>

                <Card.Subtitle className="mb-3 text-secondary" style={{ fontSize: '1rem', lineHeight: '1.6', fontWeight: '400' }}>
                    {publication.authors.join(', ')}
                </Card.Subtitle>

                <div className="mt-4 pt-3 border-top">
                    <p className="text-muted small fst-italic mb-0" style={{ color: '#64748b' }}>
                        {publication.citation}
                    </p>
                </div>
            </Card.Body>
        </Card>
    );
};

export default PublicationItem;
